import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { formatErrorMessage } from "../utils/errorMessageUtils";
export class AbstractJSONModel {
  // eslint-disable-next-line @typescript-eslint/ban-types
  static fromJSON<T extends object>(newObject: any): T {
    const me: any = this;
    const o: any = plainToClass(me, newObject);

    validate(o as T).then((errors) => {
      // errors is an array of validation errors
      if (errors.length > 0) {
        console.error("validation failed. errors: ", errors);
      }
    });

    return o as T;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  static fromJSONArray<T extends object>(newObjects: any[]): T[] {
    const me: any = this;
    const returnarray: T[] = [];
    for (let index = 0; index < newObjects.length; index++) {
      const o: any = plainToClass(me, newObjects[index]);

      validate(o as T).then((errors) => {
        // errors is an array of validation errors
        if (errors.length > 0) {
          console.error("validation failed. errors: ", errors);
        }
      });

      returnarray.push(o as T);
    }
    return returnarray;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  static async validateObject<T extends object>(object: any): Promise<string> {
    return await validate(object as T).then((errors) => {
      // errors is an array of validation errors
      if (errors.length > 0) {
        console.error("Object validation failed. errors: ", errors);
        let errorMessage = "";
        errors.forEach((error) => {
          if (error.constraints) {
            const arr = JSON.stringify(error.constraints).split('":"');
            if (arr.length > 1) {
              errorMessage += formatErrorMessage(arr[1]);
            }
          }
        });
        return errorMessage;
      } else {
        return "";
      }
    });
  }
}
